export enum QrCodeTypeEnum {
  ACTIVATE_NETFLIX = 'activate-netflix',
  ACTIVATE_DISNEY = 'activate-disney',
  MY_TELENET_RESIDENTIAL = 'mijn-telenet',
  MY_TELENET_BUSINESS = 'mijn-telenet-business'
}
